import { AppointmentI } from "@interfaces/scheduller/appointmentsI";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const practitionerAppointmentsToBeConfirmed = createSlice({
    name: 'practitionerAppointments',
    initialState: {
        practitionerAppointmentsToBeConfirmed: []
    } as { practitionerAppointmentsToBeConfirmed: AppointmentI[] },
    reducers: {
        setPractitionerAppointmentsToBeConfirmed: (state, action: PayloadAction<{practitionerAppointmentsToBeConfirmed: AppointmentI[]}>) => {
            state.practitionerAppointmentsToBeConfirmed = action.payload.practitionerAppointmentsToBeConfirmed;
        },
        cleanPractitionerAppointmentsToBeConfirmed: (state) => {
            state.practitionerAppointmentsToBeConfirmed.splice(0);
        },
    },
});

export const { setPractitionerAppointmentsToBeConfirmed, cleanPractitionerAppointmentsToBeConfirmed } = practitionerAppointmentsToBeConfirmed.actions;
export default practitionerAppointmentsToBeConfirmed.reducer;